import React from 'react';

import {Col,Row,Panel,Table} from 'react-bootstrap';

const NotificationData = (props) => {
    const {notification} = props;


    return (
        <div>
            <Panel>
                <div>
                    <img src={notification.icon} alt=""/>
                </div>
                <p>
                    <strong>Time:</strong> {notification.ts}
                </p>
            </Panel>
            <Table bordered responsive>
                <tbody>
                <tr>
                    <td>Title</td>
                    <td>{notification.title}</td>
                </tr>
                <tr>
                    <td>Body</td>
                    <td>{notification.body}</td>
                </tr>
                <tr>
                    <td>Icon</td>
                    <td>{notification.icon}</td>
                </tr>
                <tr>
                    <td>Image</td>
                    <td>{notification.image}</td>
                </tr>
                <tr>
                    <td>Badge</td>
                    <td>{notification.badge}</td>
                </tr>
                <tr>
                    <td>URL</td>
                    <td>{notification.url}</td>
                </tr>
                <tr>
                    <td>Segments</td>
                    <td>{notification.segments}</td>
                </tr>
                <tr>
                    <td>Vibration</td>
                    <td>{notification.vibration}</td>
                </tr>
                <tr>
                    <td>Sound</td>
                    <td>{notification.sound}</td>
                </tr>
                <tr>
                    <td>Button 1 Title</td>
                    <td>{notification.btn1Title}</td>
                </tr>
                <tr>
                    <td>Button 1 Icon</td>
                    <td>{notification.btn1Icon}</td>
                </tr>
                <tr>
                    <td>Button 1 URL</td>
                    <td>{notification.btn1Url}</td>
                </tr>
                <tr>
                    <td>Button 2 Title</td>
                    <td>{notification.btn2Title}</td>
                </tr>
                <tr>
                    <td>Button 2 Icon</td>
                    <td>{notification.btn2Icon}</td>
                </tr>
                <tr>
                    <td>Button 2 URL</td>
                    <td>{notification.btn2Url}</td>
                </tr>
                </tbody>
            </Table>
            <Col lg={4}>
                <Row>
                    <Table bordered responsive>
                        <tbody>
                            <tr>
                                <td><strong>Sent</strong></td>
                                <td>{notification.sent}</td>
                            </tr>
                            <tr>
                                <td><strong>Delivered</strong></td>
                                <td>{notification.delivered}</td>
                            </tr>
                            <tr>
                                <td><strong>Clicked</strong></td>
                                <td>{notification.clicked}</td>
                            </tr>
                            <tr>
                                <td><strong>Unsubscribed</strong></td>
                                <td>{notification.unsubscribed}</td>
                            </tr>
                            <tr>
                                <td><strong>Failed</strong></td>
                                <td>{notification.failed}</td>
                            </tr>
                        </tbody>
                    </Table>
                </Row>
            </Col>
        </div>
    )
}

export default  NotificationData;


// WEBPACK FOOTER //
// ./src/scenes/Notification/components/NotificationData/index.js